import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Image } from '@bonanza-social/moonlight';
import './RegisterLogos.css';

function RegisterLogos() {
  return (
    <div className="register-logos">
      <div className="separator" />
      <div className="cards-container">
        <div className="visa-card">
          <Icon name="visaCard" />
        </div>
        <div className="interac">
          <Image name="common.Interac" width={20} height={28} />
        </div>
        <div className="mastercard">
          <Icon name="masterCard" />
        </div>
      </div>
    </div>
  );
}

export default RegisterLogos;
